import { useMemo, useState } from "react";
import { Link, useNavigate, useOutletContext } from "react-router";
import { deskFact, deskFactLabel, loadAccounts } from "./internalAccounts.js";
import InternalTable from "./InternalTable.jsx";

const place = (account) => {
    const address = account.address?.[0];
    if (!address) return "No address yet";
    return [address.city, address.state].filter(Boolean).join(", ") || "Address on file";
};

const AccountTable = () => {
    const { desk } = useOutletContext();
    const navigate = useNavigate();
    const [query, setQuery] = useState("");
    const accounts = useMemo(() => loadAccounts(), []);
    const shown = accounts.filter((account) => account.accountName.toLowerCase().includes(query.trim().toLowerCase()));
    const factLabel = deskFactLabel(desk.id);

    return (
        <>
            <header className="internal-work__top">
                <div>
                    <p className="internal-work__eyebrow">{desk.label}</p>
                    <h1>Accounts</h1>
                    <p className="internal-work__lead">{desk.writes}</p>
                </div>
                <Link className="btn edit-btn" to={`/internal/${desk.id}/new`}>Add account</Link>
            </header>
            <input
                className="internal-work__search"
                value={query}
                onChange={(event) => setQuery(event.target.value)}
                placeholder="Find an account"
                aria-label="Find an account"
            />
            <InternalTable
                columns={["Account", "Place", factLabel]}
                rows={shown.map((account) => ({
                    key: account.id,
                    onClick: () => navigate(`/internal/${desk.id}/${account.id}`),
                    cells: [
                        account.accountName,
                        place(account),
                        <span className="internal-work__fact" key="fact">{deskFact(account, desk.id)}</span>,
                    ],
                }))}
            />
            {shown.length === 0 && <p className="internal-work__end">No account matches that name.</p>}
        </>
    );
};

export default AccountTable;
